import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NoDataIcon from "@material-ui/icons/Inbox"; // You can replace this with a custom icon or image.

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  icon: {
    fontSize: 64,
    marginBottom: theme.spacing(2),
    color: theme.palette.action.disabled,
  },
  message: {
    marginBottom: theme.spacing(2),
    fontSize:"25px"
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const NoDataFound = ({ message ,height }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container} style={{height:height}}>
      <NoDataIcon className={classes.icon} />
      <Typography variant="h6" className={classes.message}>
        {message}
      </Typography>
    
    </Box>
  );
};

export default NoDataFound;